import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { MatSnackBar } from "@angular/material/snack-bar";
import { Router } from "@angular/router";
import { catchError, finalize, map } from "rxjs";
import { environment } from "src/environments/environment";
import { CoreData } from "../tools/core-data/core-data";
import { mapper } from "../tools/mapping/mapper";
import { LoadingTask } from "../tools/ui/loading-task";
import { BaseService } from "./base.service";
import { EventDTO } from "./dto/event.dto";
import { Event } from "../domain/event";
import { CreateCustomEventsDto } from "./dto/create-custom-event.dto";

@Injectable({
    providedIn: 'root',
})
export class EventService extends BaseService {

    private serviceUrl = `${environment.serviceBaseUrl}api/event`;

    constructor(public http: HttpClient,
        protected override coreData: CoreData,
        protected snackBare: MatSnackBar,
        private loadingTask: LoadingTask,
        protected override router: Router) {

        super(router, coreData, snackBare);
    }

    getPlannedList(analyticalUnitCode: string, date: string) {
        this.loadingTask.activateLoading();
        return this.http.get(`${this.serviceUrl}/${analyticalUnitCode}/${date}`, this.generateHeader()).pipe(
            catchError(this.handleError<any>('getPlannedList')),
            finalize(() => this.loadingTask.deactivateLoading()),
            map((response: EventDTO[]) => {
                return response.map((item: EventDTO) => {
                    return mapper.map(item, EventDTO, Event);
                });
            }));
    }
    addCustomEvent(event: Event, list: string[]) {
    /** For one or more Sampler */
        this.loadingTask.activateLoading();

        let body = new CreateCustomEventsDto()
        body.Event = event;
        body.SamplerPuidList = list;
        return this.http.post(`${this.serviceUrl}/custom`, body, this.generateHeader()).pipe(
            catchError(this.handleError<any>('addCustomEvent')),
            finalize(() => this.loadingTask.deactivateLoading()),
            map((response: string) => {
                return response;
            }));
    }

    updateCustomEvent(event: Event) {
        this.loadingTask.activateLoading();
        return this.http.put(`${this.serviceUrl}/custom`, event, this.generateHeader()).pipe(
            catchError(this.handleError<any>('updateCustomEvent')),
            finalize(() => this.loadingTask.deactivateLoading()),
            map((response: string) => {
                return response;
            }));
    }

    deleteAllEvents(analyticalUnitCode: string, date: string) {
        this.loadingTask.activateLoading();
        return this.http.delete(`${this.serviceUrl}/${analyticalUnitCode}/${date}`, this.generateHeader()).pipe(
            catchError(this.handleError<any>('deleteAllEvents')),
            finalize(() => this.loadingTask.deactivateLoading()),
            map((response: boolean) => {
                return response;
            }));
    }

    deleteAllEventsForASampler(analyticalUnitCode: string, date: string, samplerPuid: string) {
        this.loadingTask.activateLoading();
        return this.http.delete(`${this.serviceUrl}/${analyticalUnitCode}/${date}/${samplerPuid}`, this.generateHeader()).pipe(
            catchError(this.handleError<any>('deleteAllEventsForASampler')),
            finalize(() => this.loadingTask.deactivateLoading()),
            map((response: boolean) => {
                return response;
            }));
    }

    deleteEvent(eventCode: string) {
        this.loadingTask.activateLoading();
        return this.http.delete(`${this.serviceUrl}/${eventCode}`, this.generateHeader()).pipe(
            catchError(this.handleError<any>('deleteEvent')),
            finalize(() => this.loadingTask.deactivateLoading()),
            map((response: boolean) => {
                return response;
            }));
    }
}